// ======================================================================
// File Name       : CustomButton
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import { Button } from 'react-bootstrap';

class CustomButton extends Component {

  render() {
    const { btnStyle, type = 'button', iconClass, handleClick, text, isDisabled, id, variant } = this.props;
    return (
      <Button
        className={btnStyle}
        type={type}
        onClick={handleClick}
        disabled={isDisabled}
        id={id}
        variant={variant ?? null}
      >
        {iconClass && (
          <i className={iconClass} />
        )}
        {text}
      </Button>
    );
  }
}
export default CustomButton;
